// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1fRpl","notes":"Notes_notes__11Ru2","note":"Notes_note__3mSX6","markdown":"Notes_markdown__1a5ZZ"};